/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/prefer-default-export */
import React, { useRef, useState } from 'react'
import { SimpleSwiper, SwiperSlide } from 'components/generic/SimpleSlider'
import clsx from 'clsx'
import { useMedia } from 'hooks/useMedia'
import s from './Reviews.module.css'
import { StarIcon } from './StarIcon'
import chevron from './chevron.png'

const REVIEWS = [
  {
    rating: 5,
    text: (
      <>
        Lorem ipsum dolor sit amet consectetur. Amet feugiat vulputate bibendum arcu pellentesque eget ultrices fames
        eu. Viverra laoreet phasellus erat feugiat nec tortor integer iaculis nulla. Donec netus quam auctor
        pellentesque a ut lorem.
      </>
    ),
    author: 'George C.',
  },
  {
    rating: 5,
    text: (
      <>
        Lorem ipsum dolor sit amet consectetur. Amet feugiat vulputate bibendum arcu pellentesque eget ultrices fames
        eu. Viverra laoreet phasellus erat feugiat nec tortor integer iaculis nulla. Donec netus quam auctor
        pellentesque a ut lorem.
      </>
    ),
    author: 'George C.',
  },
  {
    rating: 4,
    text: (
      <>
        Lorem ipsum dolor sit amet consectetur. Amet feugiat vulputate bibendum arcu pellentesque eget ultrices fames
        eu. Viverra laoreet phasellus erat feugiat nec tortor integer iaculis nulla. Donec netus quam auctor
        pellentesque a ut lorem.
      </>
    ),
    author: 'George C.',
  },
  {
    rating: 3,
    text: (
      <>
        Lorem ipsum dolor sit amet consectetur. Amet feugiat vulputate bibendum arcu pellentesque eget ultrices fames
        eu. Viverra laoreet phasellus erat feugiat nec tortor integer iaculis nulla. Donec netus quam auctor
        pellentesque a ut lorem.
      </>
    ),
    author: 'George C.',
  },
  {
    rating: 4,
    text: (
      <>
        Lorem ipsum dolor sit amet consectetur. Amet feugiat vulputate bibendum arcu pellentesque eget ultrices fames
        eu. Viverra laoreet phasellus erat feugiat nec tortor integer iaculis nulla. Donec netus quam auctor
        pellentesque a ut lorem.
      </>
    ),
    author: 'George C.',
  },
]

const SLIDER_PERVIEW = 3

export function Reviews() {
  const swiperRef = useRef(null)
  const [isFirst, setIsFirst] = useState(true)
  const [isLast, setIsLast] = useState(false)

  const isMobile = useMedia(['(max-width: 768px)'], [true], false)

  const handleNext = () => {
    swiperRef.current?.slideNext()
  }

  const handlePrev = () => {
    swiperRef.current?.slidePrev()
  }

  const handleChangeIndex = (currentSlideIndex) => {
    setIsFirst(currentSlideIndex === 0)
    setIsLast(currentSlideIndex === Math.round(REVIEWS.length / SLIDER_PERVIEW) - 1)
  }

  const reviews = REVIEWS.map((review, index) => (
    <SwiperSlide key={index}>
      <div className={s.review}>
        <div className={s.reviewStars}>
          {Array(review.rating)
            .fill(0)
            .map((_, i) => (
              <StarIcon key={i} className={s.reviewStar} />
            ))}
        </div>
        <div className={s.reviewText}>{review.text}</div>
        <div className={s.reviewAuthor}>{review.author}</div>
      </div>
    </SwiperSlide>
  ))

  return (
    <div className={s.root}>
      <div className={s.title}>What people are saying about us</div>
      <div className={s.desc}>
        Finding an apartment in NYC isn’t easy. Read how New Yorkers are making it happen with Nooklyn.
      </div>

      <SimpleSwiper
        ref={swiperRef}
        className={s.slider}
        slidesPerView={isMobile ? 1 : SLIDER_PERVIEW}
        spaceBetween={20}
        onChangeIndex={handleChangeIndex}
        pagination={isMobile}
      >
        {reviews}
      </SimpleSwiper>

      {!isMobile && (
        <div className={s.arrowNavigation}>
          <div className={clsx(s.arrowLeft, isFirst && s.disabled)} onClick={handlePrev}>
            <img src={chevron} className={s.arrowLeftImage} alt="left" />
          </div>
          <div className={clsx(s.arrowRight, isLast && s.disabled)} onClick={handleNext}>
            <img src={chevron} className={s.arrowRightImage} alt="right" />
          </div>
        </div>
      )}
    </div>
  )
}
